import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/shared/isolutions-ui/feedback/notifications/notification.service';
import { AuthfakeauthenticationService } from '../services/authfake.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthfakeauthenticationService,
    private router: Router,
    private notify: NotificationService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((event) => {
        if (event instanceof HttpResponse && event.body) {
          const body = event.body;

          if (body.statusCode === 401) {
            this.authService.logout();
            this.router.navigate(['/account/login'], {
              queryParams: { message: body.messageCode },
            });
          }
        }
      }),
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          this.authService.logout();
          this.router.navigate(['/account/login']);
          return throwError(() => err);
        }

        const backendMessage =
          err.error?.messageDescription ||
          err.error?.message ||
          err.message;

        if (backendMessage) {
          this.notify.error(backendMessage);
        }

        return throwError(() => backendMessage);
      }),
    );
  }
}
